export const canEditRow = (row, policy) => policy.write_columns.length > 0
  && (row.editable === true || (!policy.row_restricted && row.editable !== false));

export function changedCells(original, next, writableColumns) {
  return Object.fromEntries(writableColumns
    .filter(id => !Object.is(original.data[id] ?? '', next.data[id] ?? ''))
    .map(id => [id, next.data[id] ?? '']));
}

export function applyDrafts(rows, drafts) {
  return rows.map(row => drafts[row.line_item_id]
    ? { ...row, data: { ...row.data, ...drafts[row.line_item_id] } } : row);
}

export function draftBatches(drafts, limit = 99) {
  const batches = [];
  let batch = [], bytes = 0;
  for (const [line_item_id, data] of Object.entries(drafts)) {
    const item = { line_item_id, data };
    // Leave headroom for JSON escaping, metadata, and stored/hidden cells.
    const size = JSON.stringify(item).length * 4;
    if (batch.length && (batch.length >= limit || bytes + size > 1024 * 1024)) {
      batches.push(batch); batch = []; bytes = 0;
    }
    batch.push(item); bytes += size;
  }
  if (batch.length) batches.push(batch);
  return batches;
}
